// Wonder by Liz — Nova currency re-conversion on variant change
// Fixes: price reverting to ILS after a variant (colour) change.

function wblRefreshCurrency() {
  try {
    if (window.baCurr && typeof window.baCurr.refreshConversion === "function") {
      window.baCurr.refreshConversion();
    }
  } catch (e) {
    /* fail silently — never break the product page */
  }
}

function wblRefreshCurrencyRetry() {
  [50, 200, 500].forEach(function (delay) {
    setTimeout(wblRefreshCurrency, delay);
  });
}

document.addEventListener("product:variant-change", wblRefreshCurrencyRetry);
document.addEventListener("quickview:loaded", wblRefreshCurrencyRetry);